(function () {
  var seoRoot = document.querySelector(".pw-ai-hero[data-pw-ai-seo-title]");

  function ensureMeta(attribute, key, content) {
    if (!content) {
      return;
    }

    var selector = "meta[" + attribute + "=\"" + key + "\"]";
    var tag = document.head.querySelector(selector);

    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attribute, key);
      document.head.appendChild(tag);
    }

    tag.setAttribute("content", content);
  }

  function ensureCanonical(url) {
    if (!url) {
      return;
    }

    var link = document.head.querySelector("link[rel=\"canonical\"]");

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", url);
  }

  if (seoRoot) {
    var title = seoRoot.dataset.pwAiSeoTitle;
    var description = seoRoot.dataset.pwAiSeoDescription;
    var canonical = seoRoot.dataset.pwAiCanonical;
    var ogImage = seoRoot.dataset.pwAiOgImage;

    if (title) {
      document.title = title;
    }

    ensureMeta("name", "description", description);
    ensureCanonical(canonical);
    ensureMeta("property", "og:type", "website");
    ensureMeta("property", "og:title", title);
    ensureMeta("property", "og:description", description);
    ensureMeta("property", "og:url", canonical);
    ensureMeta("name", "twitter:card", ogImage ? "summary_large_image" : "summary");
    ensureMeta("name", "twitter:title", title);
    ensureMeta("name", "twitter:description", description);

    if (ogImage) {
      ensureMeta("property", "og:image", ogImage);
      ensureMeta("name", "twitter:image", ogImage);
    }
  }

  var faqButtons = Array.prototype.slice.call(document.querySelectorAll(".pw-ai-faq__button"));

  function setFaqState(button, expanded) {
    var item = button.closest(".pw-ai-faq__item");

    if (!item) {
      return;
    }

    item.dataset.pwAiOpen = expanded ? "true" : "false";
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  faqButtons.forEach(function (button, index) {
    button.addEventListener("click", function () {
      var isExpanded = button.getAttribute("aria-expanded") === "true";
      setFaqState(button, !isExpanded);
    });

    button.addEventListener("keydown", function (event) {
      var nextIndex = index;

      if (event.key === "ArrowDown") {
        nextIndex = (index + 1) % faqButtons.length;
      } else if (event.key === "ArrowUp") {
        nextIndex = (index - 1 + faqButtons.length) % faqButtons.length;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = faqButtons.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      faqButtons[nextIndex].focus();
    });
  });

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var animatedNodes = Array.prototype.slice.call(document.querySelectorAll("[data-pw-ai-animate]"));

  if (!reducedMotion && animatedNodes.length > 0) {
    document.documentElement.classList.add("pw-ai-motion-ready");

    animatedNodes.forEach(function (node, index) {
      node.style.setProperty("--pw-ai-delay", Math.min((index % 6) * 70, 350) + "ms");
    });

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("pw-ai-is-visible");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: "0px 0px -10% 0px",
          threshold: 0.12
        }
      );

      animatedNodes.forEach(function (node) {
        observer.observe(node);
      });
    } else {
      animatedNodes.forEach(function (node) {
        node.classList.add("pw-ai-is-visible");
      });
    }
  }
})();
